export const onPlay = (setPlaying: (playing: boolean) => void) => (): void => {
    setPlaying(true)
}

export const appendAutoPlayToURL = (youtubeVideoUrl: string): string =>
    youtubeVideoUrl.includes('?') ? `${youtubeVideoUrl}&autoplay=1` : `${youtubeVideoUrl}?autoplay=1`
